import {FC, useEffect} from "react";
import styled from "@emotion/styled";
import {Outlet} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchArticles, fetchPlayers, fetchSquads, requestProfile} from "modules/actions";
import {getIsLoadingProfile} from "modules/selectors";
import {
	Ads,
	ContextualPrompt,
	DontLoseTeamModal,
	Footer,
	Header,
	PagePreloader,
	SubHeader,
} from "components";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: 100vh;
	background: ${({theme}) => theme.colorPalette.black};
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	flex-grow: 1;
	position: relative;
`;

export const Layout: FC = () => {
	const dispatch = useDispatch();
	const isLoading = useSelector(getIsLoadingProfile);

	useEffect(() => {
		dispatch(requestProfile());
		dispatch(fetchPlayers());
		dispatch(fetchSquads());
		dispatch(fetchArticles());
	}, [dispatch]);

	if (isLoading) {
		return <PagePreloader />;
	}

	return (
		<Wrapper>
			<Header />

			<ContextualPrompt />

			<Container>
				<SubHeader />

				<Outlet />

				<Ads />
			</Container>

			<Footer />
			<DontLoseTeamModal />
		</Wrapper>
	);
};
